import Image from '@packages/shared/core/common/components/common/Image';
import ChatMessage from '../ChatMessage';
import ChatTyping from '../ChatTyping';
import styles from './ChatMessageList.module.scss';

type ChatMessageListProps = {
  incomingMessage?: string;
  outgoingMessage?: string;
  isTyping?: boolean;
  expertImage: string;
};

export const ChatMessageList = ({
  incomingMessage,
  outgoingMessage,
  expertImage,
  isTyping = false,
}: ChatMessageListProps) => {
  const hasNoMessages = !outgoingMessage && !incomingMessage;

  return (
    <div className={styles.wrapper}>
      {hasNoMessages && (
        <div className={styles.typingWrapper}>
          <Image
            src={expertImage}
            alt="expert is typing"
            width={16}
            height={16}
            type="future"
            className={styles.avatar}
          />

          <ChatTyping />
        </div>
      )}

      {incomingMessage && <ChatMessage text={incomingMessage} isIncoming={!!incomingMessage} />}

      {outgoingMessage && <ChatMessage text={outgoingMessage} isOutgoing={!!outgoingMessage} />}

      {isTyping && <ChatTyping />}
    </div>
  );
};

export default ChatMessageList;
